import ProjectsGrid from '../../components/grids/ProjectsGrid';
import AddProjectForm from '../../components/FormComps/Projects/AddProjectForm';
import EditProjectForm from '../../components/FormComps/Projects/EditProjectForm';

import { useState, useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';

import { Drawer, DrawerContent, DrawerNavigation } from '@progress/kendo-react-layout';
import { FaTimesCircle } from 'react-icons/fa';
import { submitProject, updateProject, getProjects, completeProject, deleteProject } from '../../data/projectData';
import { projectsGrid } from '../../data/interfaces';


import '../Styles.css';


const Projects = () => {
   const [projectData, setProjectData] = useState<projectsGrid[]>([]);

   const [expanded, setExpanded] = useState(false);
   const [editFormVisible, setEditFormVisible] = useState(false);
   const [addFormVisible, setAddFormVisible] = useState(false);
   const [projectId, setProjectId] = useState(0);

   const [showCompleted, setShowCompleted] = useState(false);
   const [showDeleted, setShowDeleted] = useState(false);

   const { showToast } = useToast();

   const handleShowCompleted = (value: boolean) => {
      setShowCompleted(value);
   }

   const handleShowDeleted = (value: boolean) => {
      setShowDeleted(value);
   }

   const handleAddForm = () => {
      setAddFormVisible((prevState) => (!prevState ? true : true));
      setEditFormVisible(false);
      handleExpanded();
   };

   const handleEditForm = (id: number) => {
      setProjectId(id);
      setEditFormVisible((prevState) => (!prevState ? true : true));
      setAddFormVisible(false);
      handleExpanded();
   };



   const updateProjectHandler = (dataItem: any, id: number) => {
      const projectObj = {
         projectId: id,
         clientId: dataItem.clientName.value,
         description: dataItem.description,
      };
      updateProject(projectObj, id).then(() => {
         const fetchData = async () => {
            const projectData = await getProjects(showCompleted, showDeleted);
            setProjectData(projectData);
         };
         fetchData();
      });
      handleExpanded();
      showToast('Project succesfully updated', 'success');
   };

   const newProjectHandler = (dataItem: any) => {
      const projectObj = {
         clientId: dataItem.clientName.value,
         description: dataItem.description,
      };
      submitProject(projectObj).then(() => {
         const fetchData = async () => {
            const projectData = await getProjects(showCompleted, showDeleted);
            setProjectData(projectData);
         };
         fetchData();
      });
      handleExpanded();
      showToast('Project succesfully added', 'success');
   };

   const completedProjectHandler = (id: number) => {
      completeProject(id)
         .then(() => {
            const fetchData = async () => {
               const projectData = await getProjects(showCompleted, showDeleted);
               setProjectData(projectData)
            }
            fetchData()
         })
      handleExpanded()
      showToast('Project succesfully completed', 'success');
   }

   const deleteProjectHandler = (id: number) => {
      deleteProject(id)
         .then(() => {
            const fetchData = async () => {
               const projectData = await getProjects(showCompleted, showDeleted);
               setProjectData(projectData)
            }
            fetchData()
         })
      handleExpanded()
      showToast('Project succesfully deleted', 'success');
   }

   useEffect(() => {
      const fetchData = async () => {
         const jobsData = await getProjects(showCompleted, showDeleted);
         setProjectData(jobsData);
      };

      fetchData();
   }, [showCompleted, showDeleted]);

   const handleExpanded = () => {
      setExpanded((prevState) => !prevState);
   };

   const handleSelect = () => {
      setExpanded(false);
   };

   return (
      <div>
         <Drawer
            expanded={expanded}
            position={'end'}
            width={750}
            mode="overlay"
            animation={{
               duration: 400,
            }}
            onOverlayClick={handleExpanded}
            onSelect={handleSelect}
         >
            <DrawerContent>
               <DrawerNavigation>
                  {addFormVisible && (
                     <>
                        <div className="form__title__container">
                           <h1 className="form__title">Add Project</h1>
                           <FaTimesCircle className="closeform" onClick={handleExpanded} />
                        </div>
                        <div className="form__wrapper">
                           <AddProjectForm
                              onProjectSubmit={newProjectHandler}
                           />
                        </div>
                     </>
                  )}

                  {editFormVisible && (
                     <>
                        <div className="form__title__container">
                           <h1 className="form__title">Edit Job</h1>
                           <FaTimesCircle className="closeform" onClick={handleExpanded} />
                        </div>
                        <EditProjectForm
                           onEditSubmit={updateProjectHandler}
                           onProjectId={projectId}
                           onCompleteProjectSubmit={completedProjectHandler}
                           onProjectDeleteSubmit={deleteProjectHandler}
                        />
                     </>
                  )}
               </DrawerNavigation>

               <ProjectsGrid
                  onAddToggle={handleAddForm}
                  onEditToggle={handleEditForm}
                  onData={projectData}
                  onShowCompleted={handleShowCompleted}
                  onShowDeleted={handleShowDeleted}
               />


            </DrawerContent>
         </Drawer>
      </div>
   );
};

export default Projects;
